import React from 'react';
import * as Sentry from '@sentry/browser';
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import { getSnack } from '../../utils/snackbar';
const withMediaDevices = (Component) => (props) => {
    window.AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!window.navigator || !window.navigator.mediaDevices) {
        const { t } = props;
        getSnack(props)(t('snackbar.request.invalidMediaDevice'), {
            variant: 'error',
        });
        Sentry.captureException('Browser incompatibility, `navigator.mediaDevices` missing.');
        return React.createElement("div", null);
    }
    return React.createElement(Component, Object.assign({}, props));
};
export default (Component) => withSnackbar(withTranslation()(withMediaDevices(Component)));
